import { useFirestoreGeneral, useFirestoreOrderBy } from "../../firebase/useFirestore";
import EventData from "../graphData/event/EventData";

const ReportBuilderActivityOutputs = ({ activity, startDate, endDate }  ) => {

    // Firestore
        const eventForms = useFirestoreGeneral("EventForms", "ActivityID", activity || '');
        const eventFields = useFirestoreOrderBy("EventFields", 'Position', 'asc');
        const activityFields = eventForms && eventFields && eventFields.filter(field => field.EventId === eventForms[0]?.ID);
  return (
    <div id='dashboard-output-detail-container' >
        {activityFields && activityFields.length > 0 ? activityFields.map(item => (
        <div key={item.ID} >
            {item.Type === 'date' ? null : 
                <div className='dashboard-output-detail-item-container'>
                    <EventData 
                    field={item} 
                    startDate={startDate} 
                    endDate={endDate}
                    selectedActivity={activity}
                    />
                </div>
            }
        </div>
        ))
        : <div>Geen resultaten gevonden voor deze activiteit</div>
        }
    </div>
  )
}

export default ReportBuilderActivityOutputs